import { configureStore } from '@reduxjs/toolkit'
// Import slices (will be created in Phase 2)
// import authReducer from './authSlice'
// import contractReducer from './contractSlice'

export const store = configureStore({
  reducer: {
    // auth: authReducer,
    // contract: contractReducer,
    // Add more reducers as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export default store
